import { render, staticRenderFns } from "./accomodations.vue?vue&type=template&id=7696a69e&scoped=true&"
import script from "./accomodations.vue?vue&type=script&lang=js&"
export * from "./accomodations.vue?vue&type=script&lang=js&"
import style0 from "./accomodations.vue?vue&type=style&index=0&id=7696a69e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7696a69e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7696a69e')) {
      api.createRecord('7696a69e', component.options)
    } else {
      api.reload('7696a69e', component.options)
    }
    module.hot.accept("./accomodations.vue?vue&type=template&id=7696a69e&scoped=true&", function () {
      api.rerender('7696a69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accomodation/accomodations.vue"
export default component.exports